module.exports = __webpack_public_path__ + "static/media/bg-desktop.5e51d69c.svg";